export default dispatch => ({
  changeBasemap(basemap) {
    dispatch({
      type: 'map/setIsChangingBasemap',
      payload: true
    })
    dispatch({
      type: 'map/setBasemap',
      payload: {
        name: basemap
      },
      callback: () => {
        setTimeout(() => {
          dispatch({
            type: 'map/setIsChangingBasemap',
            payload: false
          })
        }, 250)
      }
    })
  }
})
